/******************************
  FUNZIONI DI LOCAL STORAGE JS
 *****************************/

let Storage = function() {

    if (typeof(localStorage) === "undefined") {
        return false;
    }

    let put = function (key, value) {

        if(Array.isArray(value)){
            value = JSON.stringify(value);
        }
        localStorage.setItem(key, value);

    };

    let get = function (key) {

        let obj = localStorage.getItem(key);
        let response = obj;

        try {
            response = JSON.parse(obj);
        } catch(e) {
        }

        return response;

    };

    let forget = function (key) {

        localStorage.removeItem(key);

    };

    let push = function (obj, key, value) {

        if(!obj){
            obj = [value];
        } else if(Array.isArray(obj)){
            obj.push(value);
        } else {
            obj = [obj, value];
        }
        return obj;

    };

    return {

        put: function (key, value) {

            put(key, value);

        },

        get: function (key, fallback) {

            return get(key) || fallback;

        },

        has: function (key) {

            return !!get(key);
        },

        forget: function (key) {

            forget(key);

        },

        push: function (key, value) {

            let obj = this.get(key);

            obj = push(obj, key, value);

            this.put(key, obj);

        },

        pushUnique: function (key, value) {

            let obj = this.get(key);

            if(obj && Array.isArray(obj) && obj.indexOf(value) !== -1){
                return false;
            } else if(obj === value) {
                return false;
            }

            this.push(key, value);

        },

        putObject: function (key, obj) {

            obj = JSON.stringify(obj);

            this.put(key, obj);

        },

        splice: function (key, value) {

            let obj = this.get(key);

            if(!obj){ return false; }

            if(Array.isArray(obj) && obj.indexOf(value) !== -1){

                obj.splice(obj.indexOf(value), 1);

            } else if(obj === value){
                obj = null;
            }

            this.put(key, obj);

        },

        spliceMany: function (key, values) {

            if(Array.isArray(values)){

                for(let k in values) {
                    this.splice(key, values[k]);
                }

            } else {

                this.splice(key, values);

            }
        }

    };

}();